module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"answer1legend":"Perceived level","answer2legend":"Perceived importance"},"fi":{"answer1legend":"Arvioitu taso","answer2legend":"Arvioitu tärkeys"},"sv":{"answer1legend":"Upplevd nivå","answer2legend":"Upplevd vikt"},"de":{"answer1legend":"Wie gut geht es","answer2legend":"Bedeutung"},"ko":{"answer1legend":"우리 팀이 인지하고 있는 현재 수준","answer2legend":"우리 팀이 인지하고 있는 중요도"}}')
  delete Component.options._Ctor
}
